import ModuleSeparateText from './ModuleSeparateText'
import CoverImage from './CoverImage'
import SelectTwo from './SelectTwo'
import AddToList from './AddToList'
import ToggleList from './ToggleList'
import CompareSuppliers from './CompareSuppliers'
import FacetFilter from './FacetFilter'
import AnalyticsTable from './AnalyticsTable'
import FilterDropdown from './FilterDropdown'
import ListEvents from './ListEvents'

const modules = {
  ModuleSeparateText,
  CoverImage,
  SelectTwo,
  AddToList,
  ToggleList,
  FacetFilter,
  AnalyticsTable,
  FilterDropdown,
  ListEvents,
  CompareSuppliers,
}

export default modules



// WEBPACK FOOTER //
// ./scripts/modules/index.js